import React, { Component } from 'react';
import ImgsViewer from 'react-images-viewer'
import {_} from 'underscore'
import { Container } from 'react-bootstrap';
// import flickr from './flickr'

class Lightbox extends Component {
    state = { 
        imgs:[],
        currImg:0,
        isOpen: true,
        searchKey: this.props.searchKey
    }
    componentDidMount() {
        // let head = new Headers()
        // head.append('Authorization',"OAuth oauth_consumer_key=\"b5ca545fc059aa8490323c350142a0a6\",oauth_signature_method=\"HMAC-SHA1\",oauth_timestamp=\"1578219003\",oauth_nonce=\"le3BfGau8f8\",oauth_version=\"1.0\",oauth_signature=\"4BpLV1vhvyjT8E0NX%2BaoRucZIlE%3D\"")
        // let requestOptions = {
        //     method: 'GET',
        //     redirect: 'follow'
        //   };
        fetch(`https://www.flickr.com/services/rest/?method=flickr.photos.search&api_key=b5ca545fc059aa8490323c350142a0a6&user_id=8352251@N02&tags=${this.state.searchKey}&per_page=300&format=json&nojsoncallback=1`)//, requestOptions  &oauth_consumer_key=b5ca545fc059aa8490323c350142a0a6&&oauth_signature_method=HMAC-SHA1&oauth_timestamp=1578220402&oauth_nonce=5Ktu2Bo9w25&oauth_version=1.0&oauth_signature=N41y+DbCwZYyXp9NDHdDdmQYtZA=
        .then(res=>res.json())
        // .then(result=>console.log(result))
        .then(resj=>{
            console.log(resj)
            let imgs = _.map(resj.photos.photo, (p, i)=>{

                return {src: `https://farm${p.farm}.staticflickr.com/${p.server}/${p.id}_${p.secret}_b.jpg` , 
                        thumbnail:`https://farm${p.farm}.staticflickr.com/${p.server}/${p.id}_${p.secret}_t.jpg`,
                        // i: i,
                }
            })
            // console.log(imgs)
            this.setState({imgs: imgs, isOpen:true}) 
            console.log(this.state.imgs)
        })
        .catch(console.log)
        // end flickr load
        // start alternative load
        // let listEval =[]
        // switch (this.state.searchKey) {
        //     case 'models':
        //         listEval=flickr.models.photos.photo
        //         break;
        //     case 'events':
        //         listEval=flickr.events.photos.photo
        //         break;
        //     case 'street':
        //         listEval=flickr.street.photos.photo
        //         break;
        //     case 'stock':
        //         listEval=flickr.stock.photos.photo
        //         break;
        //     case 'places':
        //         listEval=flickr.places.photos.photo
        //         break;
        //     default:
        //         break;
        // }
        // let imgs = _.map(listEval, (p, i)=>{
        //     return {src: `http://farm${p.farm}.staticflickr.com/${p.server}/${p.id}_${p.secret}_z.jpg` , 
        //             thumbnail:`http://farm${p.farm}.staticflickr.com/${p.server}/${p.id}_${p.secret}_m.jpg`,
        //             // i: i,
        //     }
        // })
        // this.setState({imgs: imgs, isOpen:true})
        // console.log(this.state.imgs)
    }
    openImgsViewer = (index, event) => {
        event.preventDefault()
        this.setState({
            currImg: index,
            isOpen: true,
        })
        }
    closeImgsViewer = () => {
        this.setState({
            currImg: 0,
            isOpen: false,
        })
    }
    gotoPrev = () => {
        this.setState({
            currImg: this.state.currImg - 1
        })
    }
    gotoNext = () => {
        this.setState({
            currImg: this.state.currImg + 1
        })
    }
    gotoImg = (index) => {
        this.setState({
            currImg: index
        })
    }
    thumbClickHandler= () => {

    }
    handleClickImg =()=> {
        if (this.state.currImg === this.props.imgs.length - 1) return
        this.gotoNext()
    }
    render() { 
        return ( 
            <Container style={{paddingTop:'80px'}}>
                { this.state.imgs.length>0 ? 
                (<ImgsViewer
                    imgs={this.state.imgs}
                    currImg={this.state.currImg}
                    backdropCloseable={true}
                    isOpen={this.state.isOpen}
                    showThumbnails={true} 
                    onClickThumbnail={this.gotoImg}
                    onClickPrev={this.gotoPrev}
                    onClickNext={this.gotoNext}
                    onClose={this.closeImgsViewer}
                />)
                : null}
            </Container>
         );
    }
}


export default Lightbox;